import { BaseDto } from './base.dto';
import { ModifierGroupDto } from './modifierGroup.dto';

export class ProductModifierGroupDto extends BaseDto {
  modifierGroupId: number;
  productId: number;
  sequence: number;
  breakpoint: boolean;
  modifierGroup?: ModifierGroupDto;
}
